export const detectWebView = () => {
  if (typeof window === "undefined") {
    return false // server-side
  }
  const userAgent = window.navigator.userAgent
  // matchMedia is unavailable in some environments (e.g. jsdom); guard against it
  const standalone = typeof window.matchMedia === "function" && window.matchMedia("(display-mode: standalone)").matches

  // WebViews Android
  const isAndroidWebView = /Version\/[\d.]+.*Chrome\/[\d.]+ Mobile Safari\/[\d.]+/.test(userAgent)

  // WebViews iOS
  const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/.test(userAgent)

  return isAndroidWebView || isIOSWebView || standalone
}
